import { ResourceType } from '../../../constants'
import { Resource } from '../../../types'

/**
 * Gets the first cabin resource from a list of resources.
 * This is used to avoid displaying fitter/specialist names in the UI, preferring to show
 * cabin names instead
 *
 * @param resources - Array of resources to search through
 * @returns The first cabin resource, or undefined if none found
 */
const getCabinResource = (resources: Resource[] | undefined): Resource | undefined => {
  if (!resources) return

  return resources.find(({ type }) => type === ResourceType.CABIN)
}

export { getCabinResource }
